import React from 'react';
import Subheader from '@markinson/uicomponents-v2/Subheader';

interface IContentProps {
    text?: string;
}

const SubheaderStyles = {
    fontSize: '14px',
    fontWeight: 'bold',
    padding: 0,
    marginBottom: 10,
    color: '#777'
};

export const Heading = ({ text }) => {
    return (
        <Subheader
            style={SubheaderStyles}>
            {text}
        </Subheader>
    );
};

export const Content: React.FC<IContentProps> = ({ text }) => {
    return (
        <>
            {text?.split('\r\n').map((t, index) => (
                <Subheader
                    key={index}
                    style={{ ...SubheaderStyles, fontWeight: 'regular', color: '#000', lineHeight: 1.3 }}>
                    {t}
                </Subheader>
            ))}
        </>
    );
};
